module.exports = __webpack_public_path__ + "static/media/allToursVector.1ba2b53c.svg";